<template>
  <div class="notice-bar">
    <el-popover
      placement="bottom"
      width="380"
      trigger="click"
      v-model="visible"
      @show="fetchUnread"
    >
    <div class="notice-panel">
      <div class="notice-header">
        <span class="notice-header-title">通知</span>
        <el-button
          v-if="unreadList.length"
          type="text"
          size="mini"
          class="notice-header-action"
          @click="markAllRead"
        >全部已读</el-button>
      </div>
      <div v-loading="loading" class="notice-body">
        <div v-if="!unreadList.length && !loading" class="notice-empty">
          暂无未读通知
        </div>
        <div
          v-else
          v-for="item in unreadList"
          :key="item.id"
          class="notice-item"
          @click="markOneRead(item)"
        >
          <div class="notice-item-title">
            <i class="el-icon-bell notice-item-bell"></i>{{ item.title }}
          </div>
          <div class="notice-item-content">{{ item.content }}</div>
          <div class="notice-item-time">{{ item.create_time }}</div>
        </div>
      </div>
    </div>
    <template slot="reference">
      <div class="notice-trigger">
        <el-badge
          :value="unreadCount"
          :hidden="!unreadCount"
        >
          <i class="el-icon-bell notice-icon"></i>
        </el-badge>
      </div>
    </template>
    </el-popover>
  </div>
</template>

<script>
import { BAApi } from '@/api'

export default {
  name: 'NoticeBar',
  data() {
    return {
      visible: false,
      loading: false,
      unreadList: [],
      pollTimer: null
    }
  },
  computed: {
    unreadCount() {
      return this.unreadList.length
    }
  },
  methods: {
    async fetchUnread() {
      this.loading = true
      try {
        const res = await BAApi.getUnreadNoticeList()
        if (res.data && res.data.code === 0) {
          this.unreadList = res.data.data.notice || []
        }
      } catch (e) {
        console.error('获取未读通知失败', e)
      } finally {
        this.loading = false
      }
    },
    markOneRead(item) {
      this.markRead([item.id])
    },
    markAllRead() {
      this.markRead(this.unreadList.map(i => i.id))
    },
    async markRead(ids) {
      if (!ids || !ids.length) return
      try {
        const res = await BAApi.readNotice({ ids })
        if (res.data && res.data.code === 0) {
          this.unreadList = this.unreadList.filter(i => !ids.includes(i.id))
        }
      } catch (e) {
        console.error('标记通知已读失败', e)
      }
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => this.fetchUnread(), 30000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    }
  },
  mounted() {
    this.fetchUnread()
    this.startPolling()
  },
  beforeDestroy() {
    this.stopPolling()
  }
}
</script>

<style lang="less" scoped>
.notice-bar {
  display: inline-flex;
  align-items: center;
  margin-right: 30px;
  line-height: 1;
}
.notice-trigger {
  position: relative;
  display: inline-block;
  padding: 2px 6px;
  cursor: pointer;
  color: #fff;
  &:hover {
    color: #409eff;
  }
  .notice-icon {
    font-size: 21px;
    vertical-align: middle;
  }
}

.notice-panel {
  .notice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    .notice-header-title {
      font-size: 15px;
      font-weight: 700;
    }
    .notice-header-action {
      font-size: 12px;
    }
  }
  .notice-body {
    max-height: 400px;
    overflow-y: auto;
    .notice-empty {
      padding: 40px 0;
      text-align: center;
      color: #909399;
      font-size: 13px;
    }
    .notice-item {
      padding: 12px 4px;
      border-bottom: 1px solid #ebeef5;
      cursor: pointer;
      transition: background-color .2s;
      &:hover {
        background-color: #f5f7fa;
      }
      .notice-item-title {
        font-size: 14px;
        color: #303133;
        font-weight: 600;
        margin-bottom: 6px;
        .notice-item-bell {
          color: #f56c6c;
          margin-right: 5px;
        }
      }
      .notice-item-content {
        font-size: 13px;
        color: #606266;
        line-height: 1.5;
        margin-bottom: 6px;
      }
      .notice-item-time {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}
</style>
